<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Category
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Category Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !form.name"
            @click="save"
          >
            Update Category
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoryEditPage",
  data() {
    return {
      form: {
        name: "",
      },
      isLoading: false,
    };
  },
  computed: {
    // categoryId() {
    //   return this.$route.params.categoryId;
    // },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.categoryId;
      axios
        .get(`/categories/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log(this.form);
          this.old_json = response.data.data;
          // this.getUplineUsers();
        })
        .catch((error) => {
          // redirect to Home Page
          // window.location.href = "/auth/login";
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },

    // async fetchCategory() {
    //   this.isLoading = true;
    //   try {
    //     const response = await axios.get(`/categories/${this.categoryId}`);
    //     this.form = response.data.data || "";
    //   } catch (error) {
    //     console.error("Error fetching category:", error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    async save() {
      this.isLoading = true;
      try {
        await axios.patch(
          `/categories/${this.$route.params.categoryId}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/categories");
      } catch (error) {
        console.error("Error updating category:", error);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  padding: 20px;
}
</style>
